import React from 'react';
import { Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { getCareLogTone } from './careLogCardTheme';

const CareLogCard = ({
  category = 'log',
  tone = null,
  important = false,
  selected = false,
  variant = 'default',
  compact = false,
  showLeftRail = true,
  leftRailColor = null,
  leftRailOpacity = 0.68,
  leftRailWidth = 3,
  leftRailTop = '16%',
  leftRailBottom = '16%',
  leftRailSx = {},
  children = null,
  sx = {},
  ...paperProps
}) => {
  const resolvedTone = tone || getCareLogTone(category);
  const resolvedRailColor = leftRailColor
    || (important ? '#E7A56A' : (resolvedTone?.dot || resolvedTone?.border || '#D8E2DD'));

  const baseBg = important
    ? 'rgba(255, 245, 236, 0.78)'
    : (variant === 'story'
      ? '#FFFFFF'
      : (resolvedTone?.bg || '#FFFFFF'));

  const borderColor = selected
    ? alpha('#E7A56A', 0.85)
    : alpha(variant === 'story' ? '#DCE5DF' : (resolvedTone?.border || '#D8E2DD'), variant === 'story' ? 0.95 : 0.9);

  return (
    <Paper
      elevation={0}
      component="article"
      variant="outlined"
      sx={{
        position: 'relative',
        p: { xs: 1.6, sm: 1.85 },
        borderRadius: variant === 'story' ? '24px' : '18px',
        borderWidth: variant === 'story' ? '1px' : '0.75px',
        borderColor,
        boxShadow: variant === 'story'
          ? '0 6px 18px rgba(31, 41, 55, 0.045)'
          : '0 1px 6px rgba(20,40,30,0.035)',
        overflow: 'visible',
        boxSizing: 'border-box',
        bgcolor: baseBg,
        '&::before': showLeftRail ? {
          content: '""',
          position: 'absolute',
          left: 5,
          top: leftRailTop,
          bottom: leftRailBottom,
          width: leftRailWidth,
          borderRadius: 999,
          opacity: leftRailOpacity,
          bgcolor: resolvedRailColor,
          ...leftRailSx,
        } : undefined,
        ...sx,
      }}
      {...paperProps}
    >
      {children}
    </Paper>
  );
};

export default React.memo(CareLogCard);
